import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ExternalLinkTooltipContent } from "components/Tooltips/ExternalLinkTooltip";
import { TooltipWithIcon } from "components/Tooltips/TooltipWithIcon";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tooltipInTable: {
      width: "16px",
      height: "20px",
      opacity: "0.7",
      color: theme.gray400,
    },
  }),
);

export const ConsecutiveRuleTooltip = () => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <TooltipWithIcon
      isWhite
      className={classes.tooltipInTable}
      text={
        <ExternalLinkTooltipContent
          externalLink="https://help.openloyalty.io/main-features/members/member-list#achievement-status"
          name="streak"
          text={message({
            id: "streakInfo",
          })}
        />
      }
    />
  );
};
